
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
    showPlayerStats: {
      type: Boolean,
      default: false,
    },
    showMatchSummary: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      lastMatchStats: {},
      lastMatchStatsLoaded: false,
      seasonStats: {},
      seasonStatsLoaded: false,
      lastMatchInfo: null,
      currentTab: `Last Match`,
      loading: false,
    };
  },
  inject: [`team`, `season`],
  computed: {
    annotation () {
      return this.additionalConfig?.player_stats_config?.annotation;
    },
    tabs () {
      const allTabs = [`Last Match`, `Season Stats`, `Match Summary`];
      let tabs = [];
      if (this.showPlayerStats && this.showMatchSummary) {
        tabs = allTabs;
      } else if (this.showPlayerStats) {
        tabs = allTabs.filter(tab => tab !== `Match Summary`);
      } else if (this.showMatchSummary) {
        tabs = [`Match Summary`];
        this.setTab(`Match Summary`);
      }
      return tabs;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getLastMatchStats();
      this.getSeasonStats();
      this.getLastMatchInfo();
    });
  },
  methods: {
    async getLastMatchStats () {
      this.loading = true;
      const params = {
        tab: `last_match`,
      };
      const request = await this.$getCustomStats(`player-profile/season/${this.season.id}/player/${this.player.player.id}/team/${this.team.id}`, params);
      if (request !== null) {
        this.lastMatchStats = request;
      }
      this.lastMatchStatsLoaded = true;
      this.loading = false;
    },
    async getSeasonStats () {
      const params = {
        tab: `season_stats`,
      };
      const request = await this.$getCustomStats(`player-profile/season/${this.season.id}/player/${this.player.player.id}/team/${this.team.id}`, params);
      if (request !== null) {
        this.seasonStats = request;
      }
      this.seasonStatsLoaded = true;
    },
    async getLastMatchInfo () {
      const request = await this.$getCustomStats(`season/${this.season.id}/lastmatch/player/${this.player.player.id}/team/${this.team.id}`);
      if (request !== null) {
        this.lastMatchInfo = request.data.fixtureTeam.fixture;
      }
    },
    setTab (tab) {
      this.currentTab = tab;
    },
  },
};
